module.exports = __webpack_public_path__ + "static/img/dMRI1.63fd12cd.png";